import React from "react";
import AppLayout from "../components/Styles/AppLayout";
import LandingLayout from "../components/Styles/LandingLayout";
import Search from "../components/Search";

const SearchPage = ({ location }) => {
  const searchIndices = [
    { name: `EEDocs`, title: `EEDocs`, hitComp: `DocsHit` }
  ];
  return (
    <AppLayout location={location}>
      <LandingLayout>
        <Search collapse indices={searchIndices} />
      </LandingLayout>
    </AppLayout>
  );
};

export default SearchPage;
